import React, {useCallback, useContext, useEffect} from 'react';
import style from './style';
import commonStyle from "../style";
import clsx from "clsx";
import EAAccordion from "../../../../../components/EAAccordion";
import i18next from "i18next";
import {getContextInstances} from "../../../../../services/edge/ContexteService";
import ContextDataTable from "../../../../Context/ContextDataTable";
import {Context} from "../../../../../states/Store";

const AssociatedContext = ({context:contextModel, readOnly = false}) => {
  const {classes} = style();
  const {classes: commonClasses} = commonStyle();
  const [state, dispatch] = useContext(Context);
  const contextInstances = {
    ...state.contextInstances,
    content: [
      ...(state.contextInstances?.content || []).filter(
        (r) => r.contextModelName === contextModel.name
      )
    ]
  };

  const fetchContextInstances = useCallback(async () => {
    await getContextInstances(state.account.id, true, dispatch)
  }, [state.account, dispatch])

  useEffect(() => {
    contextModel&&fetchContextInstances();
  }, [contextModel, fetchContextInstances])

  return <div className={clsx(classes.root, commonClasses.part)} id={'context'}>
    <EAAccordion
      title={i18next.t("demandes.contextModel.ficheModel.contextLinked")}
      titleNoResult={true}
      opened={true}
      logo={'/context/contextModel/associatedContextPart'}
    >
      {contextInstances?<ContextDataTable contextInstanceList={contextInstances}/>:<></>}
    </EAAccordion>
  </div>
}

export default AssociatedContext